module.exports = __webpack_public_path__ + "img/location-off-green.6fe4edd9.svg";